import { parseConfiguratorError } from './dtos/error.js'

export abstract class ConfiguratorRequest<T, E> {
  abstract path: string
  init?: RequestInit
  expectedErrors: readonly number[] = []

  parseResponse?: (json: unknown) => T

  parseError = (status: number, json: unknown) =>
    parseConfiguratorError(status, json, this.expectedErrors) as E
}
